import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      cursor: 'pointer'
    },
    normal: {
      height: '44px',
      width: '44px',
      padding: '10px'
    },
    item: {
      background: palette.text.primary,
      borderRadius: '10px',
      height: '10%',
      margin: '10% 0',
      transition: '.4s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
      '&:nth-of-type(1)': {
        width: '50%'
      },
      '&:nth-of-type(2)': {
        width: '100%'
      },
      '&:nth-of-type(3)': {
        width: '50%'
      }
    },
    active1: {
      transformOrigin: 'bottom',
      transform: 'rotateZ(45deg) translate(22%, 0)'
    },
    active2: {
      transformOrigin: 'top',
      transform: 'rotateZ(-45deg)'
    },
    active3: {
      transformOrigin: 'bottom',
      width: '50%',
      transform: 'translate(87%, -4px) rotateZ(45deg)'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
